'use strict';

import template from './contact_form.html';
import controller from './contact_form.ctrl';

export default function f() {
  'ngInject';

  return {
    template: template,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}



// WEBPACK FOOTER //
// ./app/src/common/contact_form/contact_form.component.js